import styled from "styled-components";

export const Tituto = styled.h1`
  font-size: xx-large;
  text-align: center;
`
export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
`
export const Card = styled.div`
  width: 250px;
  margin: 20px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`
export const Image = styled.img`
  width: 250px;
  height: 200px;
  padding: 10px;
  object-fit: contain;
  background-color: #fff;
`
export const Descricao = styled.div`
  color: #000;
  padding: 0 0 10px 0;
  flex-grow: 1;
`
export const TituloCard = styled.h4`
 font-size: 20px;
`
export const Paragrafo = styled.p`
  font-size: 18px;
  padding: 0 10px;
  font-weight: 400;
`
